export default __webpack_public_path__ + "src/images/packages/kruger-sunset-lodge/e506cc91bccabf4f48a55c2e96299e5b-4.jpg";